<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="12" sm="8" lg="5">

        <div class="div-section-header">
          <b-row>
            <b-col cols="12">
              <div>
                <span class="txt-section-title">Reset Password</span>
              </div>
            </b-col>
          </b-row>
        </div>

        <transition name="fade" mode="out-in">
          <b-alert v-if="error" key="error-box" show variant="danger" class="mt-2">
            {{errorMsg}}
          </b-alert>
          <b-alert v-if="success" key="success-box" show variant="info" class="mt-2">
            Check inbox for your login credentials.
            <div class="mt-2 text-center">
              <b-button to="/login">Login</b-button>
            </div>
          </b-alert>
        </transition>

        <b-overlay :show="busy">
          <b-form @submit.prevent="recover" v-show="!success">
            <b-input-group class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="person-fill"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="username"
                v-model="form.username"
                type="text"
                placeholder="Enter username"
              ></b-form-input>
            </b-input-group>

            <b-row>
              <b-col>
                <b>-- or --</b>
              </b-col>
            </b-row>

            <b-input-group class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="envelope"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="email"
                v-model="form.email"
                type="email"
                placeholder="Enter account email address"
              ></b-form-input>
            </b-input-group>
            <b-button v-if="!busy" key="notbusy" type="submit" variant="primary" class="w-100">Recover Login</b-button>
            <!-- <b-button v-else key="isbusy" disabled type="button" variant="warning" class="w-100">Please wait.  Busy.</b-button> -->
          </b-form>
        </b-overlay>

        <div class="text-right mt-1">
          <router-link to="/login">Return to Login</router-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable */
'use strict'

// URL paramas
// https://www.thepolyglotdeveloper.com/2017/11/pass-data-between-routes-vuejs-web-application/
// import router from "../router";

import service from "../service/service";
import utils from "../utils/utils";

var data = {
  msg: "Recover Viva Account",
  show: true,
  debug: false,
  busy: false,
  error: false,
  errorMsg: "Unknown error.",
  success: false,
  classHash: "",
  form: { username: "", email: "" }
}

// using props for url parameters
// https://www.youtube.com/watch?v=ESg0k2zdME4

export default {
  name: "Recover",
  data() {
    return data;
  },
  props: { },
  computed: {
    isLoggedIn() {
        return this.$root.hasToken()
    }
  },
  methods: {
    recover(e) {
      this.error = false;
      this.success = false;
      // console.log(`u: ${this.form.username}  p: ${this.form.password}`);
      if (this.form.username.length !== 0 || this.form.email.length !== 0) {
        this.busy = true;
        service
          .resetPasswordRequest(this.form.username, this.form.email)
          .then(res => {
            if (this.debug) console.log(res.data);
            if (res.status && res.rowCount !== 0) {
              let data = res.data[0]
              if (data.status) {
                this.error = false
                this.success = true
                this.form.username = ''
                this.form.email = ''
              }
              else {
                this.success = false
                this.errorMsg = data.msg
                this.error = true
              }
              // s: ()
            } else {
              // error bad recovery
              this.error = true;
            }
          })
          .finally( () => {
            this.busy = false
          })
          .catch(e => {
            console.log(e);
            this.busy = false
            this.error = true;
          });
      }
      else {
        this.success = false
        this.busy = false
        this.errorMsg = 'Provide either username or account email address.'
        this.error = true
      }
    }
  },
  created() {
    if (this.isLoggedIn) {
      this.$router.push("/logout").then( () => { location.reload() })
    }
  },
  mounted() {

  },
  beforeDestroy() {
    this.success = false
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Recover.vue